const PATH = process.env.PUBLIC_URL;

export const images = {
  page : PATH + "/assets/images/page.png",
  //excellentClub
  ribbon: PATH + "/assets/images/ribbon.png",
  win: PATH + "/assets/images/Win.png",

  //pageBackground
  pBack: PATH + "/assets/images/pagebackground/pBack.png",
  aBack: PATH + "/assets/images/pagebackground/aBack.png",
  gBack: PATH + "/assets/images/pagebackground/gBack.png",
  eBack: PATH + "/assets/images/pagebackground/eBack.png",

  //Reservation
  admin: PATH + "/assets/images/clubLogo/admin.png",
  likelion: PATH + "/assets/images/clubLogo/likelion.png",
  pegasuss: PATH + "/assets/images/clubLogo/pegasuss.png",
  testtg: PATH + "/assets/images/testtg.png",
  testball: PATH + "/assets/images/testball.png",
  left: PATH + "/assets/images/left.png",
  right: PATH + "/assets/images/right.png",

  //rentalitems
  line: PATH + "/assets/images/rental/Line.png",
  rentalline: PATH + "/assets/images/rental/rentalline.png",
  outimg: PATH + "/assets/images/rental/outimg.png",
  delay: PATH + "/assets/images/rental/delay.png",
  notReturned: PATH + "/assets/images/rental/notReturned.png",
  quantity: PATH + "/assets/images/rental/quantity.png",

  //AdminMember
  search: PATH + "/assets/images/AdminMember/search.jpeg",
  click: PATH + "/assets/images/AdminMember/click.jpeg",

  // User_MainHeader
  UserIcon: PATH + "/assets/images/MainHeader/UserIcon.png",
  MenuIcon: PATH + "/assets/images/MainHeader/MenuIcon.png",

  // User_Header
  Home: PATH + "/assets/images/Header/Home.png",
  Back: PATH + "/assets/images/Header/Back.png",

  // Admin_Header
  adHome: PATH + "/assets/images/adminHeader/AdminHome.png",
  adBack: PATH + "/assets/images/adminHeader/AdminBack.png",

  // SNS
  insta: PATH + "/assets/images/SNS/instagram.png",
  naver: PATH + "/assets/images/SNS/naver_cafe.png",
  kakao: PATH + "/assets/images/SNS/kakao.png",

  // AdminMain
  PageLogo: PATH + "/assets/images/PageLogo.png",

  //404page
  img404 : PATH +"/assets/images/img404.png",

  //ScoreList
  toggle : PATH + "/assets/images/toggle.png",
  clubToggle : PATH + "/assets/images/clubToggle.png",
};
